export const ORG_TIMEZONE = "America/New_York";

const dayFormatter = new Intl.DateTimeFormat("en-CA", { timeZone: ORG_TIMEZONE, year: "numeric", month: "2-digit", day: "2-digit" });

/** Today's calendar date in Eastern Time as YYYY-MM-DD (never the browser's UTC day). */
export function todayET() {
  return dayFormatter.format(new Date());
}

/** Shift an ISO date (YYYY-MM-DD) by whole days without timezone drift. */
export function addDays(isoDay, days) {
  const [y, m, d] = isoDay.split("-").map(Number);
  const date = new Date(Date.UTC(y, m - 1, d + days));
  return date.toISOString().slice(0, 10);
}
